import { render, staticRenderFns } from "./UserStakingStats.vue?vue&type=template&id=556c6dc0&scoped=true&"
import script from "./UserStakingStats.vue?vue&type=script&lang=js&"
export * from "./UserStakingStats.vue?vue&type=script&lang=js&"
import style0 from "./UserStakingStats.vue?vue&type=style&index=0&id=556c6dc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556c6dc0",
  null
  
)

export default component.exports